<template>
  <modal
    ref="modal"
    v-model="visible"
    :header="false"
    :close-button="false"
    :confirm-button-label="$attrs['confirm-button-label']"
    @closed="onClosed"
    @confirmed="onConfirmed"
  >
    <button
      id="close"
      slot="before-content"
      @click.prevent="$refs.modal.close()"
    >
      <i class="af-icons af-icons-cross"></i>
    </button>
    <slot :onRequestLoginLink="onRequestLoginLink"></slot>
  </modal>
</template>

<script>
import { Modal } from 'vue-bootstrap';
import $ from 'jQuery';

export default {
  components: {
    Modal
  },
  data() {
    return {
      visible: true
    };
  },
  methods: {
    onConfirmed() {
      $('#login_password').focus();
    },
    onClosed() {
      const fieldName = $('#existsField').val() || 'registerEmail';
      const field = $(`#${fieldName}`).val();
      $('#login_login').val(field);
      $('#login_password').focus();
    },
    onRequestLoginLink() {
      $('.login-form').hide();
      $('.request-login-link-form').show();
      this.visible = false;
      const fieldName = $('#existsField').val() || 'registerEmail';
      const field = $(`#${fieldName}`).val();
      $('#requestLoginLink').val(field);
      $('#requestLoginLink').focus();
    }
  }
};
</script>
